import $ from 'jquery'
import _ from 'lodash'
import Backbone from 'backbone'
import moment from 'moment'
import DomainType from 'scoreboard/components/domain-type'
const { USER_PERMISSIONS_AUDIT } = DomainType
import ImportExportFilterPanel from 'scoreboard/admin/imports/import-export-filter-panel'
import appDisplay from 'scoreboard/components/app-display'
import calendars from 'scoreboard/components/calendars'
import conductor from 'scoreboard/components/conductor'
import globals from 'scoreboard/components/globals'
import i18n from 'scoreboard/components/i18n'
import metadata from 'scoreboard/components/metadata'
import permissions from 'scoreboard/components/permissions'
import prettyHelper from 'scoreboard/reports/common/filter/pretty-helper'
import principals from 'scoreboard/components/principals'
import projects from 'scoreboard/projects/projects'
import sections from 'scoreboard/components/sections'
import scrollContainer from 'scoreboard/components/scroll-container'
import user from 'scoreboard/components/user'
import * as websocket from 'scoreboard/components/websocket'

// Components
import CovertButtonTooltips from 'scoreboard/components/covert-button-tooltips'

import DeleteConfirmation from 'scoreboard/components/delete-confirmation'
import DisplayHeader from 'scoreboard/components/display-header'
import ScheduledExportErrorView from './scheduled-export-error-view'
import ExportForm from 'scoreboard/components/export/export-form'
import InfiniteScroller from 'scoreboard/components/infinite-scroller'
import LoadingDots from 'scoreboard/components/loading-dots'
import sendToExport from 'scoreboard/components/export/send-to-export'
import enums from 'scoreboard/components/enums'
import HistoryInfo from 'scoreboard/components/history-info'
import RefreshButton from 'scoreboard/components/refresh-button'

// Templates
import template from './scheduled-exports.hbs'

import rowTemplate from './scheduled-export-row.hbs'

const FAILED = 'failed'
/**
 * Lists all scheduled exports in a table so those with the
 * modify permission can edit/delete them.
 */
const ScheduledExports = Backbone.View.extend({

	className: 'admin scheduled-exports table-hack scroll-layout-xy display-layout form',

	events: {
		'click .text-link': 'onNavigate',
		'click .action-export': 'onExport',
		'click .action-edit': 'onEdit',
		'click .action-delete': 'onDelete',
		'click .action-history': 'onHistory'
	},

	initialize: function (options={}) {
		this.options = options
		this.exports = []
		this.loadingDots = new LoadingDots({el: this.$('.loading-dots-container')})
		this.exportById = {}
		this.refreshButtonById = {}

		//setup filter panel
		let filters =_.map(enums.toOptionData('exportType'),
				item => _.extend(item, {type:'format', group:i18n.get('common.format')}))
		this.filterPanel = new ImportExportFilterPanel({
			filterTypes: ['user','group','type','org','period','label','format', 'setupBy', 'recipients'],
			filters
		})
		this.listenTo(this.filterPanel, 'matches', ids => this._filterSelected(ids))
		this.on('resize', () => _.invoke(this.filterPanel, 'resize'))

		this._listenForUpdates()
	},

	_listenForUpdates: function () {
		websocket.latest().then(stompClient => {
			const url = `/topic/database/${globals.databaseId}/exports`
			this.statusSubscription = stompClient.subscribe(url, stompMessage => {
				// ES5 throws 'arguments is a reserved word in strict mode'
				const {id, message, arguments: args = [], stackTrace} = JSON.parse(stompMessage.body)
				const isSuccessful = message === 'success'

				// Update the cache so that we have it if they want to try again
				const exportItem = this.exportById[id]
				exportItem.stackTrace = stackTrace
				exportItem.errorMessage = isSuccessful ? undefined : message
				exportItem.errorArgument0 = _.first(args)

				// Update the UI
				const row = this.$(`[data-export-id=${id}]`)

				_.invoke(this.refreshButtonById[id], 'done')

				row.find('.error-message')
					.toggleClass('is-not-displayed', isSuccessful)
					.text(isSuccessful ? '' : i18n.get(message, args))

				row.find('.action-export')
					.toggleClass(FAILED, !isSuccessful)
					.data('action', this._getActionLabel(!isSuccessful))
			})
		})
	},

	render: function () {
		this.$el.empty().append(new DisplayHeader({
			heading: i18n.get('common.export.scheduledExports'),
			mobileGearHidden: true
		}).render().el, template())

		this.covertButtonTooltips = new CovertButtonTooltips({el: this.el})
		this.panel = this.$('.panel')
		this.tableBody = this.$('.scheduled-exports-table tbody')

		this.loadingDots = new LoadingDots({ el: this.$('.loading-dots-container') })
		this.loadingDots.render()
		this.loadingDots.observeStream(this.stream)

		this._setupScrolling()
		this._listenForData()
		return this
	},

	_setRunningIcons: function() {
		_.filter(_.values(this.exportById), {status: 'running'}).forEach(e => {
			const el = this.$(`[data-export-id=${e.id}]`).find('.action-export')
			this._showRefreshButtonForExport(el, e.id)
		})
	},

	// Event Handling
	_filterSelected: function(ids) {
		this.renderExports(ids)
	},

	_setupScrolling() {
		this.scroller = new InfiniteScroller({
			el: scrollContainer(this.el)
		})
		this.scroller.on('scroll', this.stream.next.bind(this.stream))
		this.stream.on('data', this.scroller.dataReady.bind(this.scroller))
	},

	onNavigate(evt) {
		const { id } = this._getSelectedExport(evt)
		const { domainId, requestInfo } = this.exportById[id]
		const { section, subSection } = requestInfo
		const url = getNavigateUrl(section, subSection, domainId)
		conductor.navigate(url, {trigger: true})
	},

	onExport(evt) {
		if (this.$(evt.currentTarget).hasClass('is-loading')) {
			return
		}
		const {id} = this._getSelectedExport(evt)
		const {errorMessage, errorArgument0, stackTrace} = this.exportById[id]

		if (errorMessage) {
			const errorView = new ScheduledExportErrorView({
				messageTitle: 'common.export.failed',
				messageCode: errorMessage,
				arguments: [errorArgument0],
				stackTrace
			})
			errorView.on('done', () => { // User clicked 'Try Again'
				const row = this.$(`[data-export-id=${id}]`)
				row.find('.error-message').addClass('is-not-displayed')
				$.post(`api/exports/${id}/retry`).then(() => {
					this._showRefreshButtonForExport($(evt.currentTarget), id)
				})
			})
			appDisplay.dialog(errorView)
		} else {
			sendToExport.startServerDownload(`api/exports/${id}/download`, {method: 'POST'})
		}

	},

	onEdit(evt) {
		const {id} = this._getSelectedExport(evt)
		const model = new Backbone.Model(this.exportById[id])
		const fileType = model.get('type') || model.get('requestInfo').type
		const exportForm = new ExportForm({
			model,
			showToggle: false,
			triggerType: 'schedule',
			fileType: fileType
		})
		exportForm.on('schedule', ({scheduleData, singlePeriod, recipients}) => {

			const data = JSON.stringify({ // ScheduledExport.kt
				scheduleData,
				singlePeriod, //serialized to SinglePeriod.kt, produced by calendar-range-selector.js
				timeZoneString: scheduleData.timeZone,
				recipients
			})
			$.put(`api/exports/${id}`, data).done(exportItem => {
				exportItem.orgId = model.get('orgId')
				this.exportById[exportItem.id] = exportItem

				let exportIndex =
					_.findIndex(this.exports, it => it.id === id)
				this.exports[exportIndex] = exportItem

				this._renderItem(exportItem, {replace:true})
				this._rerenderFilters()
				exportForm.trigger('done')
			})
		})
		appDisplay.dialog(exportForm)
	},

	onDelete(e) {
		var {id} = this._getSelectedExport(e)
		var description = i18n.get('common.export.scheduledExport')
		var confirmation = new DeleteConfirmation({description})
		appDisplay.dialog(confirmation)
		confirmation.once('confirm', () => {
			$.delete(`api/exports/${id}`, () => {
				$(e.target).closest('tr').remove()
				confirmation.trigger('done')
				this._toggleEmptyState(!this.$('tbody tr').length)

				_.remove(this.exports, it => it.id === id)
				this.exportById[id] = undefined

				this._rerenderFilters()
			})
		})
	},

	/**
	 * #28609 added support for showing an audit trail
	 */
	onHistory(e) {
		const selectedExport = this._getSelectedExport(e)
		selectedExport.section = 'scheduled-exports'
		HistoryInfo.display(selectedExport, i18n.get('common.export.scheduledExport'))
	},

	// JSONStream Data Handlers

	/**
	 * Invoked by JSonStreamer.on('data') from the XHR response, based on the
	 * name of the payload attribute(s), in this case 'organizations'
	 *
	 * @param {Array} organizations list of id/label objects
	 */
	setOrganizations(organizations) {
		this.organizations = organizations
		this.orgsById = _.keyBy(organizations, 'id')
		this.renderExports()
	},

	setUsers(users) {
		this.usersById = _.keyBy(users, 'id')
	},

	/**
	 * Invoked from JsonStreamer#initiate as soon as the stream is started
	 * @param {Chunker} stream
	 */
	setupStream: function(stream) {
		this.stream = stream
	},

	_listenForData: function () {
		this.stream.once('data', () => {
			this._logTimeDiff('First chunk of data received')
			this.panel.removeClass('is-not-displayed')
		})

		this.stream.on('data', data => {
			_.each(data, exportItem => {
				this.hasData = true
				// explode requestInfo attributes (url, type, section) for convenience
				_.extend(exportItem, exportItem.requestInfo)
				this.exports.push(exportItem)
				this.exportById[exportItem.id] = exportItem
				this._renderItem(exportItem)
			})
		})

		this.stream.once('data', () => {
			this._logTimeDiff('Finished listing scheduled exports')
			_.defer(() => this._logTimeDiff('Browser done rendering'))
		})

		// 'end' is emitted once from the chunker if no data received
		this.stream.on('end', () => {
			this.panel.removeClass('is-not-displayed')
			this._toggleEmptyState(this.hasData != true)
			scrollContainer(this.el).prepend(this.filterPanel.el)
			this.filterPanel.defaultFilter = this._getDefaultFilter()
			this.filterPanel.render()
			this._setRunningIcons()
		})
	},

	_getDefaultFilter: function() {
		let allSendToUsers = _.chain(this.exports)
			.map(it => [it.recipients, it.indirectRecipients])
			.flattenDeep()
			.compact()
			.filter(it => it.type === 'user')
			.uniqBy(it => principals.hashCode(it))
			.value()

		let currentUser = user.principal
		let currentUserReceivesAnyExport = !!_.find(allSendToUsers,
					it => principals.equals(it, currentUser))

		return currentUserReceivesAnyExport ?
			_.extend(currentUser, {
				group:i18n.get('common.export.sendTo')
			}) : undefined
	},

	_toggleEmptyState: function(isEmpty) {
		if (isEmpty) {
			// 35624: If we're already in the empty state, the table is already
			// detached, and the selector will come up empty, causing the
			// reference to the table to be lost, if we assign from it.
			const exportsTableEl = this.$('.scheduled-exports-table').detach()
			this.exportsTable = exportsTableEl.length ?
				exportsTableEl : this.exportsTable
			// If nothing is scheduled, empty the panel so the "none found" message will show
			this.$('.scroll-content-wrapper .panel-content').empty()
			this.$('.scheduled-exports-table').remove()
			this.$('.panel').removeClass('panel-with-table')
		} else {
			this.$('.panel').addClass('panel-with-table')
			if (this.exportsTable) {
				this.$('.scroll-content-wrapper .panel-content')
					.append(this.exportsTable)
			}
		}
	},

	//Rendering

	renderExports(filterIds) {
		let filterPredicate =
			filterIds ? (it) => filterIds.has(it.id) : () => true
		this.tableBody.empty()
		let visibleItems = _.filter(this.exports, filterPredicate)
		_.forEach(visibleItems, item => this._renderItem(item))
		this._toggleEmptyState(_.isEmpty(visibleItems))
		this.scroller.checkScroll()
	},

	/**
	 * @param {ScheduledExport.kt} exportItem
	 */
	_renderItem: function (exportItem, opts = {replace: false}) {
		const context = this._getItemContext(exportItem)

		//add the export to a store used to indicate which filters match to
		//which exports
		this.filterPanel.addItemFilter(this._assembleItemFilter(context))

		const rowHtml = rowTemplate(context)
		if (opts.replace) {
			this.tableBody.find(`tr[data-export-id=${exportItem.id}]`).replaceWith(rowHtml)
		} else {
			this.tableBody.append(rowHtml)
		}
	},

	_getItemContext: function(exportItem) {
		let {domainId, domainType, orgId, userId, fromUserId,
			requestInfo, recipients, indirectRecipients, singlePeriod,
			errorMessage} = exportItem
		const {type, periodId} = requestInfo
		const hasError = !_.isNil(errorMessage)

		// Note: Not all exports have orgs (e.g. datasets)
		const {label: orgLabel, projectId} = this.orgsById[orgId] || {}
		const projectLabel = _.get(projects.get(projectId), 'label')

		// Some exports do not have a calendar period (23936)
		let periodLabel = ''
		if (singlePeriod) {
			periodLabel = prettyHelper.periodLabels({
				range: singlePeriod
			})[0]
			if (singlePeriod.relative) {
				periodLabel += ', ' + calendars.calendarsById[singlePeriod.calendarId].label
			}
		}

		const userLabel = this.usersById[userId].label
		const setupBy = userId === fromUserId ? userLabel :
			i18n.get('common.user.createdByAs',
				this.usersById[fromUserId].label, userLabel)

		let context = _.extend({
			editable: user.equals(userId) || permissions.scheduledExports(),
			section: metadata[domainType]?.section,
			domainId,
			periodId,
			typeLabel: i18n.get(metadata[domainType]?.singularCode),
			orgLabel,
			projectLabel,
			setupBy,
			exportType: i18n.get(`common.export.${type}`),
			recipientLabels: principals.toHtml(recipients),
			periodLabel,
			userId,
			recipients,
			indirectRecipients,
			format: type,
			statusClass: hasError ? FAILED : '',
			actionLabel: this._getActionLabel(errorMessage)
		}, exportItem)

		if (domainType == USER_PERMISSIONS_AUDIT) {
			exportItem.label = this.usersById[exportItem.domainId].label
		}

		return context
	},

	_rerenderFilters: function() {
		this.filterPanel.clear()
		this.exports.forEach(currExport => {
			let context = this._getItemContext(currExport)
			this.filterPanel.addItemFilter(this._assembleItemFilter(context))
		})
		this.filterPanel.render()
	},

	_assembleItemFilter: function(item) {
		let {orgLabel, typeLabel, periodLabel, format, label, id,
			userId, recipients, indirectRecipients, setupBy} = item
		let filters = []
		let matches = []
		let indirectMatches = []
		if (orgLabel) {
			filters.push({id:orgLabel, label:orgLabel, type:'org', group:i18n.get('common.organization.organization')})
			matches.push({groupId: 'org', term: orgLabel})
		}
		if (typeLabel) {
			filters.push({id:typeLabel, label:typeLabel, type:'type', group:i18n.get('common.type')})
			matches.push({groupId: 'type', term: typeLabel})
		}
		if (periodLabel.length) {
			filters.push({id:periodLabel, label:periodLabel, type:'period', group:i18n.get('common.calendar.calendarPeriod')})
			matches.push({groupId: 'period', term: periodLabel})
		}

		filters.push({id:label, label, type:'label', group:i18n.get('common.name')})
		matches.push({groupId: 'format', term: format})
		matches.push({groupId: 'label', term: label})
		matches.push({groupId: 'user', term: userId})

		// Set up By
		filters.push({id:setupBy, label:setupBy, type:'setupBy', group:i18n.get('admin.embeddableResources.setupBy')})
		matches.push({groupId: 'setupBy', term: setupBy})

		// Send Export To
		_.each(recipients, principal => {
			filters.push({id:principal.id, label:principal.label, type:principal.type, group:i18n.get('common.export.sendTo')})
			matches.push({groupId: principal.type, term:principal.id})
		})

		// Send Export To (Indirectly)
		_.each(indirectRecipients, principal => {
			filters.push({id:principal.id, label:principal.label, type:principal.type, group:i18n.get('common.export.sendTo')})
			indirectMatches.push(principal)
		})

		return { id, filters, matches, indirectOwners: indirectMatches }
	},

	// Util

	/**
	 * The data-action value for the download button tooltip
	 * @param {boolean|String} errorMessage
	 */
	_getActionLabel(errorMessage) {
		return i18n.get(errorMessage ? 'common.resolveError' : 'common.export.download')
	},

	_getSelectedExport: function(e) {
		var data = $(e.target).closest('tr').data()
		return {
			id: data.exportId
		}
	},

	/**
	 * @param el The element that was clicked
	 * @param id The export id
	 * @private
	 */
	_showRefreshButtonForExport(el, id) {
		let refreshButton = this.refreshButtonById[id]
		if (_.isUndefined(refreshButton)) {
			refreshButton = new RefreshButton({el, actionsContainer: el.closest('.table-actions')})
			this.refreshButtonById[id] = refreshButton
		}
		refreshButton.loading()
		refreshButton.$el.data('action', i18n.get('common.export.running'))
	},

	_logTimeDiff: function (text) {
		console.log(text + ' after ' + moment().diff(this.options.start) + 'ms')
	},

	remove: function () {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invoke(this.statusSubscription, 'unsubscribe')
		_.invokeMap(_.values(this.refreshButtonById), 'remove')
		_.invokeMap([this.covertButtonTooltips, this.loadingDots, this.filterPanel], 'remove')
	}
})

function getNavigateUrl(section, subSection, domainId) {
	const permissionAudits = ['org-permissions-audit',
		'user-permissions-audit', 'dataset-permissions-audit']
	if (_.includes(permissionAudits, subSection)) {
		return `admin/${subSection}/${domainId}`
	} else {
		const prefix = section === 'calendars' ? 'admin/' : ''
		return `${prefix}${sections.toUrl(section)}/${domainId}`
	}
}

export default ScheduledExports
export { getNavigateUrl }

ScheduledExports.__filename__ = 'admin/scheduled-exports/scheduled-exports.js'
